// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"d314e208","341":"6e0eebb5","345":"f4ea8c10","356":"6ce9f51b","385":"0a82bfb0","404":"c2a8144b","410":"20bb1b5d","413":"55109b76","507":"9d0ae563","677":"ff2b55f3","680":"51053e34","872":"914aa209","904":"8e223591","916":"3649fd80"}[chunkId] + ".chunk.js";
};